module.exports = __webpack_public_path__ + "img/thumbnail_WestAfricanLion_f_normal.3e1c1b35.png";